import { useEffect, useRef } from 'react';

import Button from 'components/_parts/atoms/button';
import IconCustom from 'components/_parts/atoms/icon';
import Label from 'components/_parts/atoms/label';

function Index({
  isHide,
  setIsHide,
  datas,
  className,
  lastItem,
  style,
  position,
  type,
  setModal,
  setTypeModal,
  setChoose,
  handlePopUp,
  handleLastItem,
  ...props
}) {
  const clickOut = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (clickOut.current && !clickOut?.current?.contains(e.target)) {
        setIsHide(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [clickOut]);
  return (
    <div
      id="popUpBusinessProcess"
      ref={clickOut}
      className={`${position !== undefined ? position : 'custom_option_search'
        } ${isHide && 'show'} ${className}`}
    >
      {datas !== undefined && type !== 'search' ? (
        <>
          {datas?.map((val, index) => (
            <div
              id={`list-item-${index + 1}`}
              key={index}
              className="custom_item"
              style={{ ...style, cursor: 'pointer' }}
              onClick={() => {
                handlePopUp(val);
              }}
            >
              <IconCustom
                typeIcon={val?.icon}
                style={{ color: val?.color ? val.color : '#79FF39' }}
              />
              <Label
                style={{
                  fontSize: '12px',
                  fontWeight: '700',
                }}
              >
                {val?.name}
              </Label>
            </div>
          ))}

          {lastItem && (
            <div
              id='list-last-item'
              className="custom_item last_item"
              style={{ ...style, cursor: 'pointer' }}
              onClick={() => handleLastItem(lastItem)}
            >
              <IconCustom
                typeIcon={lastItem.icon}
                style={{ color: '#2E9CFF' }}
              />
              <Label
                style={{
                  fontSize: '12px',
                  fontWeight: '700',
                }}
              >
                {lastItem.name}
              </Label>
            </div>
          )}
        </>
      ) : datas !== undefined && type === 'search' ? (
        <div className="layout_item_search scroll_custom_search">
          {datas?.map((val, index) => (
            <div
              key={index + 1}
              className="custom_item search_item"
              style={{ ...style, cursor: 'pointer' }}
              onClick={() => {
                setIsHide(false);
                setChoose(val);
              }}
            >
              <Label>{val?.label}</Label>
              <Button
                style={{
                  backgroundColor:
                    val.type === 'primary'
                      ? '#2E9CFF'
                      : val.type === 'steering'
                        ? '#79FF39'
                        : val.type === 'support'
                          ? '#FFDF32'
                          : 'transparent',
                  height: '24px',
                  padding: '0px 20px',
                  fontWeight: '600',
                }}
              >
                {val?.type}
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div className="d-flex justify-content-center">Belum ada data</div>
      )}
    </div>
  );
}

export default Index;
